module.exports = __webpack_public_path__ + "img/product_ject_2.de0d9e8c.png";